module.exports = __webpack_public_path__ + "assets/img/shipancard.1832de2c.png";